import { type RecWizard } from '@/types/recWizard';
import { type Recommendations } from '@/types/recommendations';
import isEmpty from 'lodash/isEmpty';
import { createContext, useContext } from 'react';

export interface RecWizardContextProps {
  wizard?: Partial<RecWizard>;
  recommendations?: Recommendations;
  updateWizard: (wizard: Partial<RecWizard>) => void;
  loading: boolean;
  syncWizard: () => void;
  syncing: boolean;
  isSynced: boolean;
}

// RecWizard context with default values
export const RecWizardContext = createContext<RecWizardContextProps>({
  wizard: {},
  updateWizard: (_wizard) => {
    console.warn('Update wizard not yet defined.');
  },
  loading: false,
  syncWizard: () => {},
  syncing: false,
  isSynced: true
});

export const useRecWizard = (): RecWizardContextProps => {
  const context = useContext(RecWizardContext);
  if (isEmpty(context)) throw new Error('Called rec wizard before setting context');
  return context;
};
